import { Card, Skeleton } from '@mui/material';
import { StyledCardContent } from './styles';
import { CARD_DIMENSIONS } from '@/constants/layout';

const SkeletonCard = () => {
  return (
    <Card sx={{ width: '100%', height: CARD_DIMENSIONS.HEIGHT }}>
      <Skeleton variant="rectangular" width="100%" height={CARD_DIMENSIONS.THUMBNAIL_HEIGHT} />
      <StyledCardContent>
        <Skeleton height={20} />
        <Skeleton height={30} width="80%" />
        <Skeleton height={20} width="60%" />
      </StyledCardContent>
    </Card>
  );
};

export default SkeletonCard;
